import { IconInfoCircle } from "@tabler/icons-react";
import React from "react";

import { DocumentSettingsEditor } from "~/components/domain/settings/documents/DocumentSettingsEditor";
import { borderCrossingDetailsComposerHelpTooltip } from "~/shared/documents/border-crossing-details-composer";
import { Input, Tooltip } from "~/ui";

type BorderCrossingDocumentModalFieldsProps = {
  visible: boolean;
  /** Wait until server prefill is merged into the form so TipTap mounts with content. */
  isPrefillReady: boolean;
  /** Bumps when server prefill refetches so TipTap remounts with fresh shipment snapshots. */
  prefillDataUpdatedAt: number;
  getInputProps: (path: "borderCrossingDetails" | "borderCrossingInstructions") => React.ComponentProps<typeof DocumentSettingsEditor>;
};

const BorderCrossingDetailsLabel = () => (
  <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
    Border crossing details
    <Tooltip
      label={borderCrossingDetailsComposerHelpTooltip}
      multiline
      width={360}
      withArrow
      events={{ hover: true, focus: true, touch: true }}
    >
      <IconInfoCircle size={16} color="gray" tabIndex={0} aria-label="How border crossing details are prefilled" />
    </Tooltip>
  </span>
);

/** Layer 2 + layer 3 rich blocks when the source order has border crossing enabled. */
export const BorderCrossingDocumentModalFields = ({
  visible,
  isPrefillReady,
  prefillDataUpdatedAt,
  getInputProps,
}: BorderCrossingDocumentModalFieldsProps) => {
  if (!visible || !isPrefillReady) {
    return null;
  }
  return (
    <>
      <Input.Wrapper label={<BorderCrossingDetailsLabel />}>
        <DocumentSettingsEditor key={`border-details-${prefillDataUpdatedAt}`} {...getInputProps("borderCrossingDetails")} />
      </Input.Wrapper>
      <Input.Wrapper
        label="Border crossing procedure"
        description="Prefilled from the order's border crossing instruction (Shipping Options). Editable before create."
      >
        <DocumentSettingsEditor key={`border-procedure-${prefillDataUpdatedAt}`} {...getInputProps("borderCrossingInstructions")} />
      </Input.Wrapper>
    </>
  );
};
